import { render } from "./ImageGallery.vue?vue&type=template&id=957e981c&scoped=true"
import script from "./ImageGallery.vue?vue&type=script&lang=js"
export * from "./ImageGallery.vue?vue&type=script&lang=js"

import "./ImageGallery.vue?vue&type=style&index=0&id=957e981c&scoped=true&lang=css"

import exportComponent from "E:\\1402\\Back\\API_Core\\ApiCore\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-957e981c"]])

export default __exports__